module.exports = __webpack_public_path__ + "static/img/hotelmeister-logo-christmas.4b4baec.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/png/hotelmeister-logo-christmas.png
// module id = tL/E
// module chunks = 0